module.exports = __webpack_public_path__ + "img/thumbtack.371c9ab5.svg";